import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import DatePickerCom from "./DatePickerCom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import SelectGroup from "../../ContentManagement/firstPage/HomeOffer/SelectGroup";
import { useSnackbar } from "notistack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function GroupReport(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [name, setName] = useState("");
  const [groupState, setGroupState] = useState({
    productID: 0,
    brandID: 0,
    groupID: undefined,
    categoryID: 0,
    date1: undefined,
    date2: undefined,
  });
  const { isSmall } = useBreakpoints();

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("panel3");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  return (
    <Accordion
      id="panel3"
      expanded={props.expanded === "panel3"}
      onChange={handleChange("panel3")}
      style={{
        margin: isSmall ? 0 : "20px",
        marginBottom: isSmall && "20px",
        paddingBottom: "15px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            گزارش فروش گروه
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            p: 1,
            py: 0,
            borderRadius: 2,
          }}
        >
          <DatePickerCom state={groupState} setState={setGroupState} />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 3,
            }}
          >
            {props.expanded === "panel3" && (
              <SelectGroup
                Offer
                setName={setName}
                selectedGroupID={groupState.groupID && groupState.groupID}
                setter={setGroupState}
                lvl1State={groupState}
              ></SelectGroup>
            )}
            <Button
              disabled={!groupState.groupID ? true : false}
              onClick={() => {
                if (!groupState.date1 || !groupState.date2) {
                  enqueueSnackbar("لطفا تاریخ را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                } else if (!groupState.groupID) {
                  enqueueSnackbar("لطفا گروه را انتخاب کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                } else {
                  props.callback(groupState);
                }
              }}
              variant="contained"
            >
              نمایش
            </Button>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
